import React from 'react';
import { Messages, Control, Code, Name, Title, Actions, Form, Files, Toast, Button, API, Utility, useListContext, useCallback, useEffect, useState, Hooks } from 'helpers/ListImports';
import { Inventory } from 'models/InventoryModel';
import { InventoryColumn } from 'constants/codes';


const InventoryList: React.FC = () => {
  const width = { utncode: 8, skucode: 8, client:20, available: 10, brand:10, model:8, color: 8, size: 10, order: 10, serialno: 8 }
  const [formId, formName] = [Code.Form.Id.INVENTORY, Code.Form.Name.INVENTORY];
  const {loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [inventoryData, setInventoryData] = useState<Inventory[]>([]); 
  const [selectedInventory, setselectedInventory] = useState<Inventory | null>(null);
  const [specificationId, setSpecificationId] = useState<number>(Code.Option.Control.FRAME);
  const [stockId, setStockId] = useState<number>(Code.Option.Common.ALL);
  const [specificationOptions, setSpecificationOptions] = Hooks.Form.Options();
  const [stockOptions, setStockOptions] = Hooks.Form.Options();
  const [locationId, setLocationId] = useState<number>(Utility.Storage.LocationId());
  const [locationOptions, setLocationOptions] = Hooks.Form.Options();
  const triggers = [pno, pageRows, search, activeId, specificationId, locationId, stockId];
  const Privilege = Hooks.Privilege.List(formId);

  
  Hooks.Privilege.HasView(Privilege);

  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.SPECIFICATION, Code.Option.Common.ALL, setSpecificationOptions, setError);
    Files.Json.Http(Code.File.STOCK, Code.Option.Common.ALL, setStockOptions, setError);
    Files.Json.API(Code.File.LOCATION, Code.Option.Common.ALL, setLocationOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Inventory.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Inventory.Id, 
        Name.Inventory.UTN, 
        Name.Inventory.SKU, 
        Name.Client.Id, 
        Name.Client.FullName, 
        Name.Inventory.Data, 
        Name.Common.StatusName, 
        Name.Common.StockName, 
        Name.Inventory.SerialNo, 
        Name.Specification.Id
      ]),
      location_id: locationId,
      specification_id: specificationId,
      stock_id: stockId,
    });
    await API.Data.List<Inventory>(url, setInventoryData, setError, setLoading); 
 }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={Code.Form.Name.PURCHASE} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.PURCHASE)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId}  Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Type} value={specificationId} options={specificationOptions} onChange={setSpecificationId} />
              <Control.Dropdown title={Title.Location} value={locationId} options={locationOptions} onChange={setLocationId} />
              <Control.Dropdown title={Title.Stock} value={stockId} options={stockOptions} onChange={setStockId} />
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, inventoryData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Utncode, width.utncode], 
                [Title.Skucode, width.skucode], 
                [Title.ClientName, width.client], 
                ["Available", width.available],
                ["Brand", width.brand],
                ["Model", width.model],
                ["Colour", width.color],
                ["Size", width.size],
                ["On Order", width.order],
                [Title.Serial, width.serialno]
              ]} last={1} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(inventoryData) && (
              <Control.Grid.Row>
                {inventoryData.map((inventoryData) => { return (
                  <Control.Grid.Data<Inventory> key={inventoryData.inventory_id} itemKey={inventoryData.inventory_key} data={inventoryData} setMenuPosition={setMenuPosition} setSelectedData={setselectedInventory} setShowMenu={setShowMenu}>
                    <Control.Grid.Check keyId={inventoryData.inventory_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                    <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, Code.Form.Name.ITEM, inventoryData.inventory_id)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Text value={inventoryData.inventory_utncode} width={width.utncode} />
                    <Control.Grid.Text value={inventoryData.inventory_skucode} width={width.skucode} />
                    <Control.Grid.Link value={Utility.Get.FullName(inventoryData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(Privilege, Code.Form.Name.CLIENT, inventoryData.client_id)} width={width.client} iframeRef={iframeRef} />
                    <Control.Grid.Items values={[
                      [inventoryData.stock_name, width.available], 
                      [Utility.Get.InvDataValue(inventoryData.inventory_data, inventoryData.specification_id, InventoryColumn.BRAND), width.brand], 
                      [Utility.Get.InvDataValue(inventoryData.inventory_data, inventoryData.specification_id, InventoryColumn.MODEL), width.model], 
                      [Utility.Get.InvDataValue(inventoryData.inventory_data, inventoryData.specification_id, InventoryColumn.COLOR), width.color], 
                      [Utility.Get.InvDataValue(inventoryData.inventory_data, inventoryData.specification_id, InventoryColumn.SIZE), width.size], 
                      [inventoryData.status_name, width.order], 
                      [inventoryData.inventory_serialno, width.serialno], 
                    ]} /> 
                    <Control.Grid.Actions>
                      <Control.Action.All formName={formName} activeId={activeId} keyId={inventoryData.inventory_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                    </Control.Grid.Actions>
                  </Control.Grid.Data>)})}
              </Control.Grid.Row>
            )}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={inventoryData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, `${formName}/${selectedInventory?.inventory_key}`)} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedInventory?.inventory_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default InventoryList;